<template>
  <div class="addmodal fixed w-full h-screen z-20 top-0 left-0 flex justify-center items-start overflow-auto">
    <div class="flex justify-center items-center  h-screen">
      <form @submit.prevent="setProducts"
        class="card z-50 opacity-100 w-11/12 md:w-8/12 lg:w-6/12 lx:w-5/12 h-auto  rounded-md overflow-hidden flex flex-col items-center justify-start bg-white">
        <div class="flex justify-between items-center w-full pt-2">
          <h1
            class="font-costea w-10/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
            Editar producto
          </h1>
        </div>
        <div class="bg-gray-200 w-11/12 h-24 rounded-md relative mb-4"
          :style="`background-repeat: no-repeat; background-size: contain; background-position:center center; ${showImage}`">
          <span @click="$refs.myFiles.click()"
            class="cursor-pointer flex flex-row items-center justify-center absolute bg-costeaPrimary text-white w-10 h-10 right-4 bottom-4 rounded-full">
            <i class="ri-camera-fill text-lg"></i>
            <input type="file" @input="pickFile" @change="onSelectedImage" ref="myFiles" style="display:none" />
          </span>
        </div>
        <p v-if="errorSizeImage"
          class="text-costeaSalmon font-costea text-t12 text-left w-11/12 bg-costeaSalmonDisabled px-2 py-1 rounded-md ">
          {{ this.errorSizeImage }}</p>

        <div class="flex flex-wrap form p-2 md:p-4 w-full">

          <div class="flex w-full justify-evenly">
            <div class="flex flex-col justify-center items-start w-5/12 m-1 ">
              <label for="nombre" class="text-costeaGray text-t14 relative leading-6">Nombre del producto *</label>
              <input type="text" @input="changeNombre" :value="nombreOld" id="nombre"
                class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14"
                placeholder="">
            </div>
            <div class="flex flex-col justify-center items-start w-5/12 m-1">
              <label for="referencia" class="text-costeaGray text-t14 relative leading-6">Referencia *</label>
              <input type="text" @input='changeRef' :value="referenciaOld" id='referencia'
                class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14"
                placeholder="">
            </div>
          </div>
          <div class="flex w-full justify-evenly">
            <div class="flex flex-col justify-center items-start w-5/12 m-1">
              <label for="codigobarras" class="text-costeaGray text-t14 relative leading-6">Codigo de barras *</label>
              <input type="text" @input="changeCodigoBarras" :value="codigobarrasOld" id="codigobarras"
                class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14"
                placeholder="">
            </div>
            <div class="flex flex-col justify-center items-start w-5/12 m-1">
              <label for="tipoIdentificacion" class="text-costeaGray text-t14 relative leading-6">Categoría *</label>
              <select v-model="categoria" id="tipoIdentificacion"
                class="bg-costeaContainer w-full h-10 justify-start items-center outline-none py-2 px-3 rounded-md text-t14">
                <option v-for="cat in categories" :value="cat.id" :key="cat.id">{{ cat.name }}</option>
              </select>
            </div>
          </div>
          <div class="flex w-full justify-evenly ">
            <div class="flex flex-col justify-center items-start w-5/12 m-1">
              <label for="precioventa" class="text-costeaGray text-t14 relative leading-6">Precio de venta actual (COP)
                *</label>
              <input type="text" @input='changePrecioVenta' :value="precioventaOld" id='precioventa'
                class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14"
                placeholder="">

            </div>
            <div class="flex flex-col justify-center items-start w-5/12 m-1">

            </div>
          </div>

        </div>
        <div class="flex justify-end w-full border-t-2">
          <div class="flex flex-col justify-center items-end w-5/12 m-1">
            <div class="mb-4 p-2 flex content-center items-center w-10/12 rounded-md justify-end">
              <button
                class="bg-costeaBtn2 rounded-md text-costeaPrimary hover:bg-costeaBtn2Hover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide mr-4"
                @click="toggleModal()" type="button">Cancelar</button>
              <button @click="onProcess()"
                :class="'rounded-md text-white hover:bg-costeaHover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t12 uppercase tracking-wide ml-4 ' + buttonBg"
                type="submit">{{ buttonText }}</button>
            </div>
          </div>
        </div>
      </form>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      buttonText: 'Editar',
      buttonBg: 'bg-costeaPrimary',
      modalAct: true,
      categories: [],
      nums: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      ventana: false,
      ventanaactu: false,
      cop: false,
      usd: false,
      mensaje: false,
      accion: 'Null',
      existencia: false,
      sin_existencia: true,
      detalle: true,
      //Datos
      nombre: '',
      referencia: '',
      codigobarras: '',
      categoria: '',
      precioventa: '',

      picture: null,
      previewImage: null,

      errorSizeImage: '',

    }
  },
  props: { 'id': Number, 'nombreOld': String, 'referenciaOld': String, 'codigobarrasOld': String, 'categoriaOld': Number, 'precioventaOld': String, 'editComponents': Array, 'editcostomanoobra': String, 'admongastos': String, 'cifcostos': String, 'modirectas': String },
  mounted() {
    this.getCategories()
    console.log(this.editComponents)
  },
  computed: {
    ...mapState(['costea']),
    showImage() {
      if (this.previewImage != null) {
        return `background-image:url('${this.previewImage}');`
      } else {
        return 'background-color: #f1f2f3;'
      }
    },
  },
  methods: {
    changeNombre(event) {
      this.nombre = event.target.value
    },
    changeRef(event) {
      this.referencia = event.target.value
    },
    changeCodigoBarras(event) {
      this.codigobarras = event.target.value
    },
    changeCategory(event) {
      this.categoria = event.target.value
    },
    changePrecioVenta(event) {
      if(event.target.value != ''){
        this.precioventa = event.target.value
      }else{
        this.precioventa = this.precioventaOld
      }
    },
    onSelectedImage(event) {
      this.picture = event.target.files[0]
    },
    pickFile() {
      let input = this.$refs.myFiles
      let file = input.files
      if (file && file[0]) {
        let reader = new FileReader
        reader.onload = e => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(file[0])
      }
    },
    getCategories: function () {
      axios
        .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}categories`)
        .then(respuesta => {
          this.categories = respuesta.data;
        }).catch(
          (error) => {
            console.log(error)
          }
        );
    },
    setProducts: function () {
      this.errorSizeImage = ''
      if (this.picture && this.picture.size > 450000) {
        this.errorSizeImage = 'El tamaño de la imagen no puede ser mayor a 450kb'
        this.buttonText = 'Editar'
        return
      }

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let formData = new FormData()
      if (this.picture != null) { formData.append('picture', this.picture); }
      formData.append('nombre', this.nombre != '' ? this.nombre : this.nombreOld);
      formData.append('referencia', this.referencia != '' ? this.referencia : this.referenciaOld)
      formData.append('codigo_barras', this.codigobarras != '' ? this.codigobarras : this.codigobarrasOld)
      formData.append('id_category', this.categoria != '' ? this.categoria : this.categoriaOld)
      formData.append('precio_venta_actual', this.precioventa != '' ? Number(this.precioventa) : Number(this.precioventaOld))
      formData.append('costo_mano_obra', this.editcostomanoobra)
      formData.append('admongastos', this.admongastos)
      formData.append('cifcostos', this.cifcostos)
      formData.append('modirectas', this.modirectas)
      axios
        .post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-update/${this.$route.params.id}`, formData, config)
        .then(() => {
          setTimeout(() => {
            this.buttonText = 'Listo!'
            this.buttonBg = 'bg-costeaDarkGreen'
          }, 100)
          setTimeout(() => {
            this.toggleModal()
          }, 1000)
          setTimeout(() => {
            this.buttonText = 'Editar'
            this.buttonBg = 'bg-costeaPrimary'
          }, 3000)

        }
        ).catch(
          (error) => {
            console.log(error)
          }
        );
    },
    modalActive() {
      this.modalAct = true
      this.modalAct == true ? this.modalAct = false : this.modalAct = true
      return this.modalAct
    },
    toggleModal() {
      this.$emit('closeModalEdit', this.modalActive())
      this.$emit('reloadData', true)
    },
    onProcess() {
      this.buttonText = 'Editando...'
    }
  }
}
</script>

<style>
.addmodal {
  background: rgba(0, 0, 0, 0.8);
}
</style>